import styled from 'styled-components';
import { Tooltip as AntTooltip } from 'antd';

export const Tooltip = styled(AntTooltip)``;
